import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-[#1E2335] bg-[#07080C]">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="flex flex-col gap-12 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <img src="/images/fredline-mark.png" alt="Fredline Studios F mark" className="h-10 w-10 object-contain" />
              <span className="font-display text-2xl font-extrabold tracking-[0.15em] metal-text">Fredline Studios</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-500">
              A web design & engineering studio forging high-performance digital experiences. fredlinestudios.com
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Footer">
            <Link data-testid="footer-link-work" to="/work" className="mono-label text-slate-500 hover:text-cyan-300 transition-colors duration-200">Work</Link>
            <Link data-testid="footer-link-services" to="/services" className="mono-label text-slate-500 hover:text-cyan-300 transition-colors duration-200">Services</Link>
            <Link data-testid="footer-link-contact" to="/contact" className="mono-label text-slate-500 hover:text-cyan-300 transition-colors duration-200">Contact</Link>
            <a data-testid="footer-link-email" href="mailto:pfred@fredlinestudios.com" className="mono-label text-slate-500 hover:text-cyan-300 transition-colors duration-200">pfred@fredlinestudios.com</a>
          </nav>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-[#1E2335] pt-6 sm:flex-row sm:items-center sm:justify-between">
          <span className="font-mono text-[11px] tracking-[0.2em] text-slate-600">© 2026 FREDLINE STUDIOS — ALL RIGHTS RESERVED</span>
          <span className="font-mono text-[11px] tracking-[0.2em] text-slate-600">BUILT ABOVE THE STANDARD</span>
        </div>
      </div>
    </footer>
  );
}
